import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Card from "../../components/Card";
import Goback from "../../components/Goback";
import { AuthService } from "../../services/AuthService";
import { Button, Input, Select, Typography, message } from "antd";
import styled from "styled-components";
import { UserContext } from "../../context/userContext";

const { Text } = Typography;

// const roles = [
//     {
//         value: "User",
//         label: "User"
//     },
//     {
//         value: "Manager",
//         label: "Manager"
//     },
//     {
//         value: "Administrator",
//         label: "Administrator"
//     },
// ]

const NewUser = () => {

   
    const {user} = useContext(UserContext)

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [allowEdit, setAllowEdit] = useState(false);

    const [messageApi, contextHolder] = message.useMessage();

    const location = useLocation();

    const [userData, setUserData] = useState({
        id: null,
        fullName: null,
        userName: null,
        email: null,
        roleName: null,
        password: "",
        confirmPassword: "",
        storeId: null
    });

    const [stores, setStores] = useState([]);

    const [roles, setRoles] = useState([]);

    const [newRole, setNewRole] = useState(null);


    const saveUser = async () => {
        const { fullName, password, email, roleName, confirmPassword } = userData;

        if (!fullName || !password || !email) {
            messageApi.open({
                type: 'error',
                content: 'Ploteso fushat e shenuara me *',
            });

            return;
        }
        if (password !== confirmPassword) {
            messageApi.open({
                type: 'error',
                content: 'Fjalekalimi per verifikim qe keni shenuar nuk perputhet',
            });

            return;
        }
        // if (roleName == "Manager" && storeId == null) {
        //     messageApi.open({
        //         type: 'error',
        //         content: 'Keni zgjedhur rolin Menagjer, caktojini nje pike shitjeje',
        //     });

        //     return;
        // }
        let res = await AuthService.register(userData);


        if (res?.status == 409) {
            messageApi.open({
                type: 'error',
                content: 'Perdoruesi egziston',
            });


        }
        else {
            setTimeout(() => {
                setLoading(false);
                navigate(`/users`);
            }, 1000);
        }
    }

    const updateUser = async () => {
        const { id, fullName, password, email, roleName, confirmPassword } = userData;

        if (!id || !fullName || !email) {
            messageApi.open({
                type: 'error',
                content: 'Ploteso fushat e shenuara me *',
            });
            return;
        }

        let res = await AuthService.updateUser(id, {
            userName: email,
            fullName: fullName,
            assignedStoreName: null,
            roleName: null
        })
        if (res && res?.id) {
            messageApi.open({
                type: 'success',
                content: 'Vlerat u ndryshuan me sukses',
            });
        }
        else {
            if (res?.length > 0) {
                messageApi.open({
                    type: 'error',
                    content: res[0]['description']
                });
            }

        }
    }

    const getStores = async () => {
        // setLoading(true);
        let res = await AuthService.getStores({});
        console.log("res", res);
        if (res?.items && res?.items.length > 0) {
            setStores(res?.items);
        }
        // setLoading(false);
    }

    const getAllRoles = async () => {
        // setLoading(true);
        let res = await AuthService.getAllRoles({});
        console.log("roles", res);
        if (res) {
            let formated = res?.map(role => {
                // let updatedEl = { ...role };
                let updatedEl = {
                    value: role?.id,
                    label: role?.roleName
                }
                return updatedEl
            })
            setRoles(formated);
        }
        // setLoading(false);
    }

    const assignRole = async () => {

        console.log({
            userId: userData?.id,
            roleId: newRole,
            storeId: 1
        })

        let res = await AuthService.assignRole({
            userId: userData?.id,
            roleId: newRole,
            storeId: 11
        })

        if (res) {
            messageApi.open({
                type: 'success',
                content: res?.message
            });
        }

        console.log("res", res);
    }


    const roleHandler = (value) => {
    
        if (value != "Manager") {
            setUserData({ ...userData, storeId: null })
        }
        setUserData({ ...userData, roleName: roles.find(role=>role.value == value)?.label})

    }

    const getUserById = async (userId) => {
        console.log("userId", userId)
        let res = await AuthService.getUserById(userId);

        console.log("get user by id", res);

        if (res) {
            res.email = res?.userName;
            setUserData(res);
        }
    }

    const editHandler = () => {
        setAllowEdit(!allowEdit);
    }


    useEffect(() => {
        if (location.state?.user) {
            console.log("state", location?.state?.user)
            // setUserData({ ...location.state.user });
            // location.state.user = null;
            getUserById(location?.state?.user?.id)

        }
        else {
            setAllowEdit(true)
        }
        getStores();
        getAllRoles();
    }, [])

    return (
        <div className="container">
            {contextHolder}
            <div className="col-12">
                <Goback />
            </div>
            <div className="row">
                <div className="col-8">
                    <Card title={userData?.id ? "Perditeso llogarine" : "Krijo llogari te re"}>

                        <div className="row">
                            <div className="col-12">
                                {userData?.id &&
                                    <>
                                        <Button style={{ marginRight: 10 }} onClick={editHandler}>{allowEdit ? 'Anulo perditesimin' : 'Perditeso te dhenat'}</Button>
                                        {/* <Button type="primary" danger> Delete user</Button> */}
                                    </>}
                            </div>
                        </div>
                        <Seperator />
                        <div className="row">
                            <div className="col-6">
                                <Text>Emri i plote*</Text>
                                <Input disabled={!allowEdit} value={userData?.fullName} onChange={(e) => setUserData({ ...userData, fullName: e.target.value })} />
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-6 mt-3">
                                <Text>Email *</Text>
                                <Input disabled={!allowEdit} value={userData?.email} onChange={(e) => setUserData({ ...userData, email: e.target.value })} />
                            </div>
                            {/* <div className="col-6 mt-3">
                                <Text>Telefoni</Text>
                                <Input disabled={!allowEdit} value={null} onChange={(e) => setUserData({ ...user, userName: e.target.value })} />
                            </div> */}

                        </div>
                        <Seperator />
                        {!user?.id && (
                            <div className="row">
                                <div className="col-6">
                                    <Text>Fjalekalimi *</Text>
                                    <Input disabled={!allowEdit} type="password" value={userData?.password} onChange={(e) => setUserData({ ...userData, password: e.target.value })} />
                                </div>
                                <div className="col-6">
                                    <Text>Konfirmo fjalekalimin *</Text>
                                    <Input disabled={!allowEdit} type="password" value={userData?.confirmPassword} onChange={(e) => setUserData({ ...userData, confirmPassword: e.target.value })} />
                                </div>
                            </div>
                        )}
                        <div className="row">
                            <div className="col-12 mt-3">
                                <div className="d-flex justify-content-end">
                                    <Button loading={loading} disabled={loading || !allowEdit} type="primary" onClick={location?.state?.user ? updateUser : saveUser}>Ruaj Perdoruesin</Button>
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>

                {userData && userData.id && (
                    
                    <div className="col-4">
                         
                        <Card title={"Role Handler"}>
                            <Text>Roli</Text>
                            <Select
                                disabled={!allowEdit}
                                labelInValue
                                defaultValue={userData?.roleName}
                                style={{ width: "100%" }}
                                onChange={(e: any) => {

                                    setNewRole(e?.value)
                                    roleHandler(e?.value);
                                }}
                                options={roles}
                            />
                            {(user?.details?.roleName == "Admin" && userData?.roleName == "Manager" )&& <div className="col-12">
                                <Text>Pika per menaxhim</Text>
                                {stores && <Select
                                    disabled={!allowEdit}
                                    labelInValue
                                    defaultValue={userData?.storeId}
                                    style={{ width: "100%" }}
                                    onChange={(e: any) => {

                                        setUserData({ ...userData, storeId: e?.value })
                                    }}
                                    options={stores?.map(item => ({
                                        value: item?.storeId,
                                        label: item?.storeName.toUpperCase()
                                    }))}
                                />}
                            </div>}

                            <Button className="mt-3" loading={loading} disabled={loading || !allowEdit || !newRole  || (newRole == "Manager" && !userData?.storeId)} type="primary" onClick={assignRole}>Ndrysho rolin</Button>
                        </Card>
                    </div>
                )}

            </div>
        </div>

    )
}


export default NewUser;

export const Seperator = styled.div`
height: 1px;
background-color: #EAEAEA;
margin: 25px 0;
`